import React from 'react';
import { Link, hashHistory } from 'react-router';
import { connect } from 'react-redux';
import HeaderSmall from '../Components/Header/HeaderSmall';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import { Card, CardActions, CardText } from 'material-ui/Card';
import TabStrip from '../Components/TabStrip';
import getMuiTheme from 'material-ui/styles/getMuiTheme';

class AccountPage extends React.Component {

    toSupport = () => {
        hashHistory.push("/account/support");
    }

    render() {

        return (
            <div>
                <HeaderSmall title="My Account" />
                <div className="container" >
                <Card>
                        <CardText>
                            {(this.props.member) && (
                                <div>
                                    <h3><b>Name</b></h3>  
                                    <h5>{this.props.member.FirstName} {this.props.member.LastName}</h5>
                                    <br />
                                    <h3><b>Username</b></h3>
                                    <h5>{this.props.member.EmailAddress}</h5>
                                </div>
                            )}
                        </CardText>
                        <CardActions>
                            <FlatButton
                                label="Change My Password"
                                primary={true}
                                containerElement={<Link to={"account/password"} /> }
                            >
                            </FlatButton>
                        </CardActions>
                    </Card>
                    <br />
                    <br />
                    <RaisedButton
                        label="Privacy Policy"
                        default={true}
                        fullWidth={true}
                        containerElement={<Link to={"go/privacy"} />} 
                    >
                    </RaisedButton>
                    <br />
                    <br />
                    <RaisedButton
                        label="Terms of Use"
                        default={true}
                        fullWidth={true}
                        containerElement={<Link to={"go/terms"} />} 
                    >
                    </RaisedButton>
                    <br />
                    <br />

                    <RaisedButton
                        default={true}
                        labelStyle={{color:'rgb(255, 64, 129)'}}
                        containerElement={<Link to={"account/delete"} />} 
                        label={'Delete My Account'}
                        fullWidth={true}
                        ></RaisedButton>
                    {/* <br />
                    <br />
                    <RaisedButton
                        label="Contact Support"
                        default={true}
                        fullWidth={true}
                        onClick={this.toSupport}
                    >
                    </RaisedButton> */}
                </div>
                <TabStrip activeTab={4} />
            </div>
        );
    }
};

const mapStateToProps = (state) => ({
    member: state.thisApp.auth.member
})

export default connect(
  mapStateToProps
)(AccountPage);



// WEBPACK FOOTER //
// ./src/Pages/Account.js